"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PER_TICKET_NUM = exports.ACT_SIGN = exports.REDEEM_TYPE = exports.RESULT_REVOCATION_STATUS = exports.PRIZE_TYPE_LABEL_MAP = exports.PRIZE_TYPES = exports.PRIZE_TYPE = exports.SUB_ROUTES = void 0;
exports.isPrizeType = isPrizeType;
// Sub-activity route constants (shared between frontend & backend)
exports.SUB_ROUTES = {
    AMOE: '/amoe',
    GIVEAWAY: '/giveaway',
    INVENTORY: '/inventory',
    TRANSFER: '/transfer',
    /** 通用兑换（actSign + apiPrizeSign + fimoo 订单号） */
    REDEMPTION: '/redemption',
};
/** 奖品类型 */
exports.PRIZE_TYPE = {
    /** 实物奖品（需要用户兑换并提供信息） */
    PHYSICAL: 'physical',
    /** 门票类奖品（需要用户兑换并提供信息） */
    TICKET: 'ticket',
    /** 线上虚拟奖品（由 fimoo 直接发放，无需用户领取动作） */
    VIRTUAL: 'virtual',
};
/** 受控奖品类型列表，供管理台和后端校验复用。 */
exports.PRIZE_TYPES = Object.values(exports.PRIZE_TYPE);
/** 奖品类型文案映射 */
exports.PRIZE_TYPE_LABEL_MAP = {
    [exports.PRIZE_TYPE.PHYSICAL]: '实物奖品',
    [exports.PRIZE_TYPE.TICKET]: '门票类奖品',
    [exports.PRIZE_TYPE.VIRTUAL]: '线上虚拟奖品',
};
function isPrizeType(value) {
    return exports.PRIZE_TYPES.includes(value);
}
/** 中奖结果作废状态 */
exports.RESULT_REVOCATION_STATUS = {
    /** 有效 */
    VALID: 0,
    /** 已作废 */
    REVOKED: 1,
};
/** 兑换类型 */
exports.REDEEM_TYPE = {
    TICKET: 1,
    PHYSICAL: 2,
};
/** 活动标识 */
exports.ACT_SIGN = {
    GIVEAWAY: 'giveaway',
    REFERRAL: 'referral',
    TRANSFER: 'transfer',
    REDEMPTION: 'redemption',
};
/** 每次门票兑换固定张数 */
exports.PER_TICKET_NUM = 2;
